/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

export type BTAdminBuilderPreference =
  (typeof BTAdminBuilderPreference)[keyof typeof BTAdminBuilderPreference];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BTAdminBuilderPreference = {
  notificationHistoryRedesign: "notificationHistoryRedesign",
  taskManagementOptIn: "taskManagementOptIn",
  estimateCostCodeGroupModifications: "estimateCostCodeGroupModifications",
  selectionOptionDocumentScraping: "selectionOptionDocumentScraping",
  jcbViewDropdown: "jcbViewDropdown",
  subsAuth0Migration: "subsAuth0Migration",
  permissionsMfaEnrollmentCohort: "permissionsMfaEnrollmentCohort",
  rFIOwnersV1: "rFIOwnersV1",
  bdsContentHeaderListPageReplacement: "bdsContentHeaderListPageReplacement",
  worksheetAGGrid: "worksheetAGGrid",
  estimateMobileServices: "estimateMobileServices",
  sageARPayments: "sageARPayments",
  sageSync: "sageSync",
  paymentMethodUI: "paymentMethodUI",
  paymentsSetupTab: "paymentsSetupTab",
  tasksGeneralJob: "tasksGeneralJob",
  billsFullPageConversion: "billsFullPageConversion",
  changeOrdersNewItemHeader: "changeOrdersNewItemHeader",
  bdsContentHeaderIndividualReplacements:
    "bdsContentHeaderIndividualReplacements",
  budgetCostCodeCaching: "budgetCostCodeCaching",
  bulkExport: "bulkExport",
  sageIntacctMVP: "sageIntacctMVP",
  taskDependencies: "taskDependencies",
  enterSubPaymentContactInfo: "enterSubPaymentContactInfo",
  scanAllBillAttachments: "scanAllBillAttachments",
  editBillPercentage: "editBillPercentage",
  inFlightWorkflowEdits: "inFlightWorkflowEdits",
  timeClockLegacyGeneralJobCleanup: "timeClockLegacyGeneralJobCleanup",
  markupCostCodeRollup: "markupCostCodeRollup",
  lienWaiversMassPay: "lienWaiversMassPay",
  useNotificationsEmail: "useNotificationsEmail",
  selfServiceMfaManagement: "selfServiceMfaManagement",
  plansViewerReducedTileSize: "plansViewerReducedTileSize",
  conditionalBillApprovals: "conditionalBillApprovals",
  taskGantt: "taskGantt",
  scopeOfWorkMobileCardView: "scopeOfWorkMobileCardView",
  bdsContentHeaderModalReplacement: "bdsContentHeaderModalReplacement",
  tasksCustomFieldSortTweaks: "tasksCustomFieldSortTweaks",
  allocateBillCostsAcrossMultipleJobs: "allocateBillCostsAcrossMultipleJobs",
  rfiBluebeam: "rfiBluebeam",
  customForwardEmailAlias: "customForwardEmailAlias",
  partialPaymentLienWaivers: "partialPaymentLienWaivers",
  selectionsReimagined: "selectionsReimagined",
  aIASignatureWorkflow: "aIASignatureWorkflow",
  sageInvoice: "sageInvoice",
  gustoUpgrade: "gustoUpgrade",
  massShiftDelete: "massShiftDelete",
  progressInvoiceRevisedBudgetColumn: "progressInvoiceRevisedBudgetColumn",
  xeroReconnectAfterError: "xeroReconnectAfterError",
  aiaPurchaseOrder: "aiaPurchaseOrder",
  financialEntityNumbering: "financialEntityNumbering",
  disableToDos: "disableToDos",
  useRemoteEmailClassification: "useRemoteEmailClassification",
  lowesInCompanySettings: "lowesInCompanySettings",
  infoArchOptIn: "infoArchOptIn",
  vendorCreditOCRDetection: "vendorCreditOCRDetection",
  subMissingPaymentInfoOnBill: "subMissingPaymentInfoOnBill",
  deferBillsPermissionCalls: "deferBillsPermissionCalls",
  trackAllowanceProgress: "trackAllowanceProgress",
  mobileInAppFeedback: "mobileInAppFeedback",
  watchingForTasks: "watchingForTasks",
  achBankSetupEmailPreview: "achBankSetupEmailPreview",
  billAccountingSyncMoment: "billAccountingSyncMoment",
  invoiceCreationAlignment: "invoiceCreationAlignment",
  improvedSubLienWaivers: "improvedSubLienWaivers",
  requireStepUpAuthForOutboundPayments: "requireStepUpAuthForOutboundPayments",
  tasksCalendarFeed: "tasksCalendarFeed",
  schedulePagedGanttPrint: "schedulePagedGanttPrint",
  selectionsAICostCodeMatching: "selectionsAICostCodeMatching",
  autoFillInvoice: "autoFillInvoice",
  progressInvoiceRetainageIndicator: "progressInvoiceRetainageIndicator",
  taxesChangeOrders: "taxesChangeOrders",
  estimateActivityLog: "estimateActivityLog",
  billPaymentScheduling: "billPaymentScheduling",
  bulkRoleManagement: "bulkRoleManagement",
  apBillRetainage: "apBillRetainage",
  mobileWebviewExperience: "mobileWebviewExperience",
  taskDependenciesShifting: "taskDependenciesShifting",
  paymentsControllerRefactor: "paymentsControllerRefactor",
  bluebeamIntegration: "bluebeamIntegration",
  multiInvoicePdfSplitDetectionReview: "multiInvoicePdfSplitDetectionReview",
  finalUnconditionalLienWaivers: "finalUnconditionalLienWaivers",
  multipleLienWaiversOnBills: "multipleLienWaiversOnBills",
  enableNutrientPhotoDraw: "enableNutrientPhotoDraw",
  invoiceRelatedEntityLineItemTags: "invoiceRelatedEntityLineItemTags",
  sharePaymentScheduleOnAllFixedPriceJobs:
    "sharePaymentScheduleOnAllFixedPriceJobs",
  paymentScheduleAfterSendToBudget: "paymentScheduleAfterSendToBudget",
  costInboxMigration: "costInboxMigration",
  disableSubOwnerExternalEmails: "disableSubOwnerExternalEmails",
  invoiceHideLaborCostsDefault: "invoiceHideLaborCostsDefault",
  taskPhaseDemo: "taskPhaseDemo",
  qbdWebConnectorHangfireDefer: "qbdWebConnectorHangfireDefer",
  globalSpecCatalog: "globalSpecCatalog",
  billsAgGridMigration: "billsAgGridMigration",
  aIPreliminaryEstimate: "aIPreliminaryEstimate",
  selectionOptionsLineItemCard: "selectionOptionsLineItemCard",
  specPublishPushNotifications: "specPublishPushNotifications",
  enableSpecPublishNotifications: "enableSpecPublishNotifications",
  genericLinkingSpecsToCO: "genericLinkingSpecsToCO",
  specInternalOnlyPublish: "specInternalOnlyPublish",
  linkPlansToSubmittals: "linkPlansToSubmittals",
  quickBooksMigrationInvoices: "quickBooksMigrationInvoices",
  plansMultiDocRevisions: "plansMultiDocRevisions",
  messagesAllowMobileVideoUploads: "messagesAllowMobileVideoUploads",
  jpsFinancialOverviewRevamp: "jpsFinancialOverviewRevamp",
  billsAccountingExport: "billsAccountingExport",
  aiPoweredSearchV1: "aiPoweredSearchV1",
  taskAssistantOptIn: "taskAssistantOptIn",
  estimateWorksheetPanelView: "estimateWorksheetPanelView",
  taxesSelectionChoices: "taxesSelectionChoices",
  globalSpecCostGroupLinking: "globalSpecCostGroupLinking",
  dailyLogsAutoSave: "dailyLogsAutoSave",
  plansAiVersionSummary: "plansAiVersionSummary",
  splitBillsPOsBudgetSettings: "splitBillsPOsBudgetSettings",
  mobileDirectoryAddExperience: "mobileDirectoryAddExperience",
  massShiftCreation: "massShiftCreation",
  defaultSpcOn: "defaultSpcOn",
  aiPoweredSearch: "aiPoweredSearch",
  jcbFind: "jcbFind",
  selectionsReimaginedSignatures: "selectionsReimaginedSignatures",
  billsMobileConversion: "billsMobileConversion",
  defaultMarkAsBillableInQB: "defaultMarkAsBillableInQB",
  specsRelatedItemLinkEnhancements: "specsRelatedItemLinkEnhancements",
  scheduleCompleteInvoiceReadyNotification:
    "scheduleCompleteInvoiceReadyNotification",
  templateSupportForSelectionOptions: "templateSupportForSelectionOptions",
  expenseAccountingSync: "expenseAccountingSync",
  warrantiesModalConversion: "warrantiesModalConversion",
  legacyBuildersSriTemplateSupport: "legacyBuildersSriTemplateSupport",
  achReturnEmail: "achReturnEmail",
} as const;
